module.exports = __webpack_public_path__ + "img/vertical-divider.2925533e.svg";